import { render, staticRenderFns } from "./Nbpf.vue?vue&type=template&id=39760b12&scoped=true&"
import script from "./Nbpf.vue?vue&type=script&lang=js&"
export * from "./Nbpf.vue?vue&type=script&lang=js&"
import style0 from "./Nbpf.vue?vue&type=style&index=0&id=39760b12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39760b12",
  null
  
)

component.options.__file = "Nbpf.vue"
export default component.exports